var productCardMarkup = `
  <table class="wishlist-table">
  <thead>
      <tr>
        <th>{{tableheading1}}</th>
        <th>{{tableheading2}}</th>
        <th>{{tableheading3}}</th>
        <th>{{tableheading4}}</th>
      </tr>
  </thead>
  <tbody>
  {{#products}} 
    <tr>
      <td><div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div></td>
      <td>
        <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
          <div class="swym-title swym-title-1">
          	{{dt}}
          </div>
        </a>
        <div class="swym-sku"><span>{{skutitle}}</span> {{sku}}</div>
        <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
            <span>{{varianttitle}}</span> {{variantinfo}}
        </div>
        <div class="swym-product-price swym-text swym-text-1">
            <div class="swym-product-final-price swym-value">
                <span>{{pricetitle}}</span>{{#checkPrice}} <s>{{cu}}{{pr}}</s> {{checkPrice}}{{/checkPrice}}{{^checkPrice}} {{cu}}{{pr}}{{/checkPrice}}
            </div>
        </div>
      </td>
      <td>{{stocktitle}} {{#checkStock}}{{instock}}{{/checkStock}} {{^checkStock}}{{outofstock}}{{/checkStock}}</td>
      <td>
            <div class="date-added-wishlist">
              {{datetitle}}{{dateAdded}}
            </div>
          <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button" style="{{^checkStock}}pointer-events:none{{/checkStock}}">
          {{#isInCart}}
              {{addedtobag}}
          {{/isInCart}}
          {{^isInCart}}
              {{#checkStock}}
                {{addtobag}}
              {{/checkStock}}
              {{^checkStock}}
                {{outofstock1}}
              {{/checkStock}}
          {{/isInCart}}
          </button>
          <div class="remove-from-wishlist">
            <a href="#" id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">{{remove}}</a>            
          </div>
      </td>
    </tr>
  {{/products}}
    <!-- Add more rows as needed -->
  </tbody>
</table>  
  `;

// Get the wishlist values
var wishlist = window.customWishlist,
  salePrice = null;

// Replace the placeholders in the template with the actual values from the wishlist
productCardMarkup = productCardMarkup
  .replace('{{tableheading1}}', wishlist.tableheading1)
  .replace('{{tableheading2}}', wishlist.tableheading2)
  .replace('{{tableheading3}}', wishlist.tableheading3)
  .replace('{{tableheading4}}', wishlist.tableheading4)
  .replace('{{addtobag}}', wishlist.addtobag)
  .replace('{{addedtobag}}', wishlist.addedtobag)
  .replace('{{remove}}', wishlist.remove)
  .replace('{{outofstock}}', wishlist.outofstock)
  .replace('{{outofstock1}}', wishlist.outofstock)
  .replace('{{instock}}', wishlist.instock);

function getVariantInfo(variants) {
  try {
    let variantKeys = variants && variants != '[]' ? Object.keys(JSON.parse(variants)[0]) : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == 'Default Title') {
        variantinfo = '';
      }
    } else {
      variantinfo = '';
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

// Function to convert Unix timestamp to date
function convertUnixTimestampToDate(unixTimestamp) {
  // Create a new Date object and pass the Unix timestamp as milliseconds
  var date = new Date(unixTimestamp);
  var day = date.getDate(); // Get the day of the month (1-31)
  var month = date.getMonth(); // Get the month (0-11)
  var year = date.getFullYear(); // Get the full year (e.g., 2024)

  // Month names array for conversion
  var monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // Convert the month number to month name
  var monthName = monthNames[month];
  var formattedDate = day + ' ' + monthName + ' ' + year;
  return formattedDate;
}

function formatPrice(price) {
  // Ensure price is a string, remove .00, and return formatted price
  return price.replace(/\.00$/, '');
}

function checkPrice(salePrice) {
  if (salePrice && window.customWishlist.privateSale) {
    return salePrice.innerText;
  } else {
    return null;
  }
}

async function checkStockAvailability(pHandle, vID) {
  try {
    const response = await fetch(pHandle);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const contentType = response.headers.get('Content-Type');
    let data;
    if (contentType && contentType.includes('application/json')) {
      data = await response.json();
    } else {
      data = await response.text();
    }

    if (typeof data === 'string') {
      // Parse the HTML string
      const parser = new DOMParser();
      salePrice = null;
      const doc = parser.parseFromString(data, 'text/html');

      // Find the div with the class "inventoryStockWrapper"
      const inventoryStockQtyElement = doc.querySelector('.inventoryStockWrapper #inventory-' + vID);
      const regularPriceEle = doc.querySelector('.price__regular s.variant-item__old-price');
      if (regularPriceEle) {
        salePrice = doc.querySelector('.price__regular span.price-item--regular');
      }
      if (inventoryStockQtyElement) {
        const inventoryStockQty = inventoryStockQtyElement.value;
        if (parseInt(inventoryStockQty) > 0) {
          return true;
        } else {
          return false;
        }
      }
    } else {
    }
  } catch (error) {
    console.error('Error:', error);
    return 'Error retrieving stock availability';
  }
}

async function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(async function (products) {
    const wishlistContentsContainer = document.getElementById('wishlist-items-container');
    const formattedWishlistedProducts = await Promise.all(
      products.map(async function (p) {
        p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
        p.variantinfo = p.vi ? getVariantInfo(p.vi) : '';
        p.dateAdded = convertUnixTimestampToDate(p.uts);
        p.checkStock = await checkStockAvailability(p.du, p.epi);
        p.checkPrice = checkPrice(salePrice);
        
        // Apply formatting to regular and sale prices to remove .00
        if (p.pr) {
          p.pr = formatPrice(p.pr);  // Format regular price
        }
        if (salePrice && salePrice.innerText) {
          salePrice.innerText = formatPrice(salePrice.innerText);  // Format sale price
        }
        
        p.skutitle = window.customWishlist.skutitle;
        p.varianttitle = window.customWishlist.varianttitle;
        p.pricetitle = window.customWishlist.pricetitle;
        p.stocktitle = window.customWishlist.stocktitle;
        p.datetitle = window.customWishlist.datetitle;
        return p;
      })
    );
    const productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else {
    }
  });
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute('data-product-id');
  var variantId = e.currentTarget.getAttribute('data-variant-id');
  var du = e.target.getAttribute('data-product-url');
  e.target.innerHTML = 'Adding..';
  const formData = new FormData();
  // Update cart using the existing cart rendering logic
  const cart = document.querySelector('cart-popup');
  const cartDrawerWrapper = document.querySelector('cart-drawer');

  formData.append('id', variantId);
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  // Create a new URL object
  const urlObject = new URL(du);

  // Get the pathname from the URL object
  const p_pathname = urlObject.pathname;
  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', p_pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        // Handle error
        console.error(response.errors || response.description);
        return;
      }
      if (cart) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
          cartData: response,
        });
        cart.renderContents(response);
        e.target.innerHTML = 'Added to bag';
        e.target.setAttribute('data-state-cart', 'swym-added');
      }
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
    })
    .finally(() => {
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      // Check if both classes exist before removing them
      if (cartDrawerWrapper.classList.contains('is-empty') && cartDrawerWrapper.classList.contains('ob-cart-empty')) {
        removeCartDrawerClasses(cartDrawerWrapper, ['is-empty', 'ob-cart-empty']);
      }
    });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll('#swym-custom-add-toCartBtn');
  var removeBtns = document.querySelectorAll('#swym-remove-productBtn');
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute('data-variant-id');
  var empi = +e.currentTarget.getAttribute('data-product-id');
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}
